import { fromJS } from 'immutable';
import { basicSort } from '../../../../util/sortUtils';

import {
  tsuVisibleColumns,
  refVisibleColumns,
  tsuSort,
  refSort,
} from '../../../EditReduxConstant';


export const CLEAR_EDIT_RUNUP = 'CLEAR_EDIT_RUNUP';

export const GET_EDIT_RUNUP_REQUEST = 'GET_EDIT_RUNUP_REQUEST';
export const GET_EDIT_RUNUP_SUCCESS = 'GET_EDIT_RUNUP_SUCCESS';
export const GET_EDIT_RUNUP_FAILURE = 'GET_EDIT_RUNUP_FAILURE';

export const UPDATE_EDIT_RUNUP_REQUEST = 'UPDATE_EDIT_RUNUP_REQUEST';
export const UPDATE_EDIT_RUNUP_SUCCESS = 'UPDATE_EDIT_RUNUP_SUCCESS';
export const UPDATE_EDIT_RUNUP_FAILURE = 'UPDATE_EDIT_RUNUP_FAILURE';

export const CREATE_EDIT_RUNUP_REQUEST = 'CREATE_EDIT_RUNUP_REQUEST';
export const CREATE_EDIT_RUNUP_SUCCESS = 'CREATE_EDIT_RUNUP_SUCCESS';
export const CREATE_EDIT_RUNUP_FAILURE = 'CREATE_EDIT_RUNUP_FAILURE';


export const EDIT_RUNUP_TSUNAMI_REQUEST = 'EDIT_RUNUP_TSUNAMI_REQUEST';
export const EDIT_RUNUP_TSUNAMI_SUCCESS = 'EDIT_RUNUP_TSUNAMI_SUCCESS';
export const EDIT_RUNUP_TSUNAMI_FAILURE = 'EDIT_RUNUP_TSUNAMI_FAILURE';

export const EDIT_RUNUP_TSUNAMI_SEARCH_REQUEST = 'EDIT_RUNUP_TSUNAMI_SEARCH_REQUEST';
export const EDIT_RUNUP_TSUNAMI_SEARCH_SUCCESS = 'EDIT_RUNUP_TSUNAMI_SEARCH_SUCCESS';
export const EDIT_RUNUP_TSUNAMI_SEARCH_FAILURE = 'EDIT_RUNUP_TSUNAMI_SEARCH_FAILURE';


export const EDIT_RUNUP_REFERENCE_REQUEST = 'EDIT_RUNUP_REFERENCE_REQUEST';
export const EDIT_RUNUP_REFERENCE_SUCCESS = 'EDIT_RUNUP_REFERENCE_SUCCESS';
export const EDIT_RUNUP_REFERENCE_FAILURE = 'EDIT_RUNUP_REFERENCE_FAILURE';

export const EDIT_RUNUP_REFERENCE_SEARCH_REQUEST = 'EDIT_RUNUP_REFERENCE_SEARCH_REQUEST';
export const EDIT_RUNUP_REFERENCE_SEARCH_SUCCESS = 'EDIT_RUNUP_REFERENCE_SEARCH_SUCCESS';
export const EDIT_RUNUP_REFERENCE_SEARCH_FAILURE = 'EDIT_RUNUP_REFERENCE_SEARCH_FAILURE';

export const EDIT_RUNUP_REGION_REQUEST = 'EDIT_RUNUP_REGION_REQUEST';
export const EDIT_RUNUP_REGION_SUCCESS = 'EDIT_RUNUP_REGION_SUCCESS';
export const EDIT_RUNUP_REGION_FAILURE = 'EDIT_RUNUP_REGION_FAILURE';

export const EDIT_RUNUP_COUNTRY_REQUEST = 'EDIT_RUNUP_COUNTRY_REQUEST';
export const EDIT_RUNUP_COUNTRY_SUCCESS = 'EDIT_RUNUP_COUNTRY_SUCCESS';
export const EDIT_RUNUP_COUNTRY_FAILURE = 'EDIT_RUNUP_COUNTRY_FAILURE';

export const EDIT_RUNUP_AREA_REQUEST = 'EDIT_RUNUP_AREA_REQUEST';
export const EDIT_RUNUP_AREA_SUCCESS = 'EDIT_RUNUP_AREA_SUCCESS';
export const EDIT_RUNUP_AREA_FAILURE = 'EDIT_RUNUP_AREA_FAILURE';

export const EDIT_RUNUP_LOCATION_REQUEST = 'EDIT_RUNUP_LOCATION_REQUEST';
export const EDIT_RUNUP_LOCATION_SUCCESS = 'EDIT_RUNUP_LOCATION_SUCCESS';
export const EDIT_RUNUP_LOCATION_FAILURE = 'EDIT_RUNUP_LOCATION_FAILURE';

export const EDIT_RUNUP_FIRST_MOTION_REQUEST = 'EDIT_RUNUP_FIRST_MOTION_REQUEST';
export const EDIT_RUNUP_FIRST_MOTION_SUCCESS = 'EDIT_RUNUP_FIRST_MOTION_SUCCESS';
export const EDIT_RUNUP_FIRST_MOTION_FAILURE = 'EDIT_RUNUP_FIRST_MOTION_FAILURE';

export const EDIT_RUNUP_MEASUREMENT_TYPE_REQUEST = 'EDIT_RUNUP_MEASUREMENT_TYPE_REQUEST';
export const EDIT_RUNUP_MEASUREMENT_TYPE_SUCCESS = 'EDIT_RUNUP_MEASUREMENT_TYPE_SUCCESS';
export const EDIT_RUNUP_MEASUREMENT_TYPE_FAILURE = 'EDIT_RUNUP_MEASUREMENT_TYPE_FAILURE';

export const EDIT_RUNUP_REFERENCE_SORT = 'EDIT_RUNUP_REFERENCE_SORT';
export const EDIT_RUNUP_TSUNAMI_SORT = 'EDIT_RUNUP_TSUNAMI_SORT';

export const EDIT_RUNUP_OPEN_CONFIRMATION = 'EDIT_RUNUP_OPEN_CONFIRMATION';
export const EDIT_RUNUP_CANCEL_CONFIRMATION = 'EDIT_RUNUP_CANCEL_CONFIRMATION';

export const EDIT_RUNUP_REFERENCE_TOGGLE_COLUMN = 'EDIT_RUNUP_REFERENCE_TOGGLE_COLUMN';
export const EDIT_RUNUP_TSUNAMI_TOGGLE_COLUMN = 'EDIT_RUNUP_TSUNAMI_TOGGLE_COLUMN';

const initialState = fromJS({
  fetched: false,
  runup: {
    referenceIds: [],
  },
  updating: false,

  tsunami: {},
  fetchedTsunami: false,
  tsunamiSearchResults: [],
  tsunamiSearching: false,

  references: [],
  fetchedReferences: false,
  referenceSearchResults: [],
  referenceSearching: false,


  fetchedRegions: false,
  regions: [],
  fetchedCountries: false,
  countries: [],
  fetchedAreas: false,
  areas: [],
  fetchedLocations: false,
  locations: [],
  fetchedFirstMotions: false,
  firstMotions: [],
  fetchedMeasurementTypes: false,
  measurementTypes: [],

  tsuSort,
  refSort,
  tsuVisibleColumns,
  refVisibleColumns,

  formData: {},
  editConfirmationOpen: false,

});

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const runupEditReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_EDIT_RUNUP:
      return initialState;

    case EDIT_RUNUP_OPEN_CONFIRMATION:
      return state.merge(fromJS({
        formData: action.formData,
        editConfirmationOpen: true,
      }));
    case EDIT_RUNUP_CANCEL_CONFIRMATION:
      return state.merge(fromJS({
        formData: {},
        editConfirmationOpen: false,
      }));

    case GET_EDIT_RUNUP_REQUEST:
      return state.merge(fromJS({
        fetched: false,
        updating: false,
      }));
    case CREATE_EDIT_RUNUP_REQUEST:
    case UPDATE_EDIT_RUNUP_REQUEST:
      return state.merge(fromJS({
        fetched: false,
        updating: true,
      }));
    case CREATE_EDIT_RUNUP_SUCCESS:
    case UPDATE_EDIT_RUNUP_SUCCESS:
      return state.merge(fromJS({
        fetched: true,
        runup: action.response,
        updating: false,
        formData: {},
        editConfirmationOpen: false,
      }));
    case GET_EDIT_RUNUP_SUCCESS:
      return state.merge(fromJS({
        fetched: true,
        runup: action.response,
        updating: false,
      }));
    case CREATE_EDIT_RUNUP_FAILURE:
    case UPDATE_EDIT_RUNUP_FAILURE:
      return state.merge(fromJS({
        fetched: false,
        updating: false,
        formData: {},
        editConfirmationOpen: false,
      }));
    case GET_EDIT_RUNUP_FAILURE:
      return state.merge(fromJS({
        fetched: false,
        updating: false,
      }));


    case EDIT_RUNUP_TSUNAMI_SORT:
      return state.merge(fromJS({
        tsunamiSearchResults: basicSort(action.sort, state.get('tsunamiSearchResults')),
        tsuSort: action.sort,
      }));

    case EDIT_RUNUP_TSUNAMI_REQUEST:
      return state.merge(fromJS({
        fetchedTsunami: false,
      }));
    case EDIT_RUNUP_TSUNAMI_SUCCESS:
      return state.merge(fromJS({
        fetchedTsunami: true,
        tsunami: action.response,
      }));
    case EDIT_RUNUP_TSUNAMI_FAILURE:
      return state.merge(fromJS({
        fetchedTsunami: true,
      }));

    case EDIT_RUNUP_TSUNAMI_SEARCH_REQUEST:
      return state.merge(fromJS({
        tsunamiSearching: true,
      }));
    case EDIT_RUNUP_TSUNAMI_SEARCH_SUCCESS:
      return state.merge(fromJS({
        tsunamiSearching: false,
        tsunamiSearchResults: basicSort(state.get('tsuSort'), fromJS(action.response.items)),
      }));
    case EDIT_RUNUP_TSUNAMI_SEARCH_FAILURE:
      return state.merge(fromJS({
        tsunamiSearching: false,
      }));


    case EDIT_RUNUP_REFERENCE_SORT:
      return state.merge(fromJS({
        referenceSearchResults: basicSort(action.sort, state.get('referenceSearchResults')),
        refSort: action.sort,
      }));

    case EDIT_RUNUP_REFERENCE_REQUEST:
      return state.merge(fromJS({
        fetchedReferences: false,
      }));
    case EDIT_RUNUP_REFERENCE_SUCCESS:
      return state.merge(fromJS({
        fetchedReferences: true,
        references: action.response.items,
      }));
    case EDIT_RUNUP_REFERENCE_FAILURE:
      return state.merge(fromJS({
        fetchedReferences: true,
      }));

    case EDIT_RUNUP_REFERENCE_SEARCH_REQUEST:
      return state.merge(fromJS({
        referenceSearching: true,
      }));
    case EDIT_RUNUP_REFERENCE_SEARCH_SUCCESS:
      return state.merge(fromJS({
        referenceSearching: false,
        referenceSearchResults: basicSort(state.get('refSort'), fromJS(action.response.items)),
      }));
    case EDIT_RUNUP_REFERENCE_SEARCH_FAILURE:
      return state.merge(fromJS({
        referenceSearching: false,
      }));

    case EDIT_RUNUP_REGION_REQUEST:
      return state.merge(fromJS({
        fetchedRegions: false,
      }));
    case EDIT_RUNUP_REGION_SUCCESS:
      return state.merge(fromJS({
        fetchedRegions: true,
        regions: action.response.items,
      }));
    case EDIT_RUNUP_REGION_FAILURE:
      return state.merge(fromJS({
        fetchedRegions: true,
      }));

    case EDIT_RUNUP_COUNTRY_REQUEST:
      return state.merge(fromJS({
        fetchedCountries: false,
      }));
    case EDIT_RUNUP_COUNTRY_SUCCESS:
      return state.merge(fromJS({
        fetchedCountries: true,
        countries: action.response.items,
      }));
    case EDIT_RUNUP_COUNTRY_FAILURE:
      return state.merge(fromJS({
        fetchedCountries: true,
      }));

    case EDIT_RUNUP_AREA_REQUEST:
      return state.merge(fromJS({
        fetchedAreas: false,
      }));
    case EDIT_RUNUP_AREA_SUCCESS:
      return state.merge(fromJS({
        fetchedAreas: true,
        areas: action.response.items,
      }));
    case EDIT_RUNUP_AREA_FAILURE:
      return state.merge(fromJS({
        fetchedAreas: true,
      }));

    case EDIT_RUNUP_LOCATION_REQUEST:
      return state.merge(fromJS({
        fetchedLocations: false,
      }));
    case EDIT_RUNUP_LOCATION_SUCCESS:
      return state.merge(fromJS({
        fetchedLocations: true,
        locations: action.response.items,
      }));
    case EDIT_RUNUP_LOCATION_FAILURE:
      return state.merge(fromJS({
        fetchedLocations: true,
      }));

    case EDIT_RUNUP_FIRST_MOTION_REQUEST:
      return state.merge(fromJS({
        fetchedFirstMotions: false,
      }));
    case EDIT_RUNUP_FIRST_MOTION_SUCCESS:
      return state.merge(fromJS({
        fetchedFirstMotions: true,
        firstMotions: action.response.items,
      }));
    case EDIT_RUNUP_FIRST_MOTION_FAILURE:
      return state.merge(fromJS({
        fetchedFirstMotions: true,
      }));

    case EDIT_RUNUP_MEASUREMENT_TYPE_REQUEST:
      return state.merge(fromJS({
        fetchedMeasurementTypes: false,
      }));
    case EDIT_RUNUP_MEASUREMENT_TYPE_SUCCESS:
      return state.merge(fromJS({
        fetchedMeasurementTypes: true,
        measurementTypes: action.response.items,
      }));
    case EDIT_RUNUP_MEASUREMENT_TYPE_FAILURE:
      return state.merge(fromJS({
        fetchedMeasurementTypes: true,
      }));

    case EDIT_RUNUP_REFERENCE_TOGGLE_COLUMN:
      return state.merge(fromJS({
        refVisibleColumns: action.visibleColumns,
      }));

    case EDIT_RUNUP_TSUNAMI_TOGGLE_COLUMN:
      return state.merge(fromJS({
        tsuVisibleColumns: action.visibleColumns,
      }));

    default:
      return state;
  }
};
